import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
var Directions;
(function (Directions) {
    Directions["futures"] = "\u0424\u044C\u044E\u0447\u0435\u0440\u0441";
    Directions["spot"] = "\u0421\u043F\u043E\u0442";
})(Directions || (Directions = {}));
var DirectionsKeys;
(function (DirectionsKeys) {
    DirectionsKeys["futures"] = "futures";
    DirectionsKeys["spot"] = "spot";
})(DirectionsKeys || (DirectionsKeys = {}));
export default Vue.extend({
    props: {
        opened: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        currencies: ['USDT', 'BTC', 'ETH', 'BNB', 'XRP', 'USDC', 'FDUSD', 'TUSD'],
        activeCurrency: 'USDT',
        platforms: {
            futures: {
                value: Directions.futures,
                key: DirectionsKeys.futures,
                additionalValue: {
                    USDT: '',
                    BNB: ''
                }
            },
            spot: {
                value: Directions.spot,
                key: DirectionsKeys.spot,
                additionalValue: {
                    USDT: '',
                    BNB: ''
                }
            }
        },
        transferDirection: {
            directionFrom: DirectionsKeys.futures,
            directionTo: DirectionsKeys.spot
        },
        transfersFormValid: false,
        transfersValue: '',
        transfersFieldTouched: false,
        transfersValueRules: [],
        transferIsLoading: false
    }),
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        storeState: 'getMainPageWidget',
        isTransferLoad: 'getLoadInnerTransfersDataLoadStatus',
        getFuturesSettings: 'getFuturesSettings',
        getPositionsTable: 'getPositionsTable',
        getFuturesAdditionalCoins: 'getFuturesAdditionalCoins'
    })), { isActive() {
            return this.storeState('futuresWidget').loadError || this.storeState('spotWidget').loadError;
        },
        showAllButtons() {
            if (!this.getFuturesSettings.multiAssets)
                return this.transfersValue.length === 0;
            return this.transfersValue.length === 0 && !this.showWarningIcon;
        }, tooltipText() {
            let result = this.NS(this.transfersValue).isLessThanOrEqualTo(this.NS(0)) || this.transfersValue === '' ? this.$t('mainPage.widgets.innerTransfers.errors.typeAmount') : '';
            if (this.NS(this.selectFromValues.additionalValue).isLessThanOrEqualTo(this.NS(0)))
                result = this.$t('mainPage.widgets.innerTransfers.errors.notEnough');
            return result;
        },
        letDoTransfer() {
            return this.transfersFormValid && this.NS(this.transfersValue).isGreaterThan(this.NS(0));
        }, hasPositionsAndMASet() {
            if (!this.getFuturesSettings.multiAssets)
                return false;
            return this.getPositionsTable.items.length > 0;
        }, haveNegativeCoinValue() {
            return this.getFuturesAdditionalCoins.some((coin) => coin.value.lt(0));
        },
        haveAnyOpenPositions() {
            return this.getPositionsTable.items.length > 0;
        },
        commonConditionToShowApproxSign() {
            return (this.haveNegativeCoinValue || this.haveAnyOpenPositions) && this.getFuturesSettings.multiAssets;
        },
        showWarningIcon() {
            return this.commonConditionToShowApproxSign && this.transferDirection.directionFrom === 'futures';
        },
        prependSignFrom() {
            const isFutures = this.transferDirection.directionFrom === 'futures';
            const hasPositiveBalance = this.NS(this.storeState('innerTransfersWidget')[this.transferDirection.directionFrom].additionalValue[this.activeCurrency]).gt(0);
            return hasPositiveBalance && isFutures && this.commonConditionToShowApproxSign ? '≈' : '';
        }, prependSignTo() {
            const isFutures = this.transferDirection.directionTo === 'futures';
            const hasPositiveBalance = this.NS(this.storeState('innerTransfersWidget')[this.transferDirection.directionTo].additionalValue[this.activeCurrency]).gt(0);
            return hasPositiveBalance && isFutures && this.commonConditionToShowApproxSign ? '≈' : '';
        }, selectFromValues() {
            const wallet = this.transferDirection.directionFrom;
            return {
                value: this.$t(this.platforms[wallet].value),
                additionalValue: this.NS(this.storeState('innerTransfersWidget')[wallet].additionalValue[this.activeCurrency]),
                wallet
            };
        },
        transformedCurrencies() {
            return this.currencies.map((currency) => {
                return { key: currency, value: currency };
            });
        },
        selectToValues() {
            const wallet = this.transferDirection.directionTo;
            const result = {
                value: this.$t(this.platforms[wallet].value),
                additionalValue: this.NS(this.storeState('innerTransfersWidget')[wallet].additionalValue[this.activeCurrency]),
                wallet
            };
            return result;
        },
        platformList() {
            return Object.values(this.platforms).map((platform) => (Object.assign(Object.assign({}, platform), { value: this.$t(platform.value) })));
        } }),
    watch: {
        activeCurrency() {
            this.transfersValue = '';
        },
        transfersFieldTouched(v) {
            const vm = this;
            if (v) {
                vm.transfersValueRules = [
                    (v) => {
                        const currentVal = vm.NS(v);
                        const userBalanceCurrentCoin = vm.NS(vm.storeState('innerTransfersWidget')[vm.transferDirection.directionFrom].additionalValue[vm.activeCurrency]);
                        return (currentVal.lte(userBalanceCurrentCoin) || v === '') || this.$t('mainPage.widgets.innerTransfers.errors.notEnoughInSetAccount');
                    }
                ];
            }
            else {
                vm.transfersValueRules = [];
            }
        },
        isTransferLoad(value) {
            const { coinToTransfer } = this.$route.query;
            if (value && coinToTransfer) {
                this.handleClickSetAll();
                this.$router.replace({ query: null });
            }
        },
        'transferDirection.directionFrom'(v, oldV) {
            const vm = this;
            vm.transfersValue = '';
            if (vm.transferDirection.directionTo === v) {
                vm.transferDirection.directionTo = oldV;
            }
        },
        'transferDirection.directionTo'(v, oldV) {
            const vm = this;
            vm.transfersValue = '';
            if (vm.transferDirection.directionFrom === v) {
                vm.transferDirection.directionFrom = oldV;
            }
        }
    },
    filters: {
        formatDirectionName(v, revert, vm) {
            if (v === DirectionsKeys.futures)
                return revert ? vm.$t('mainPage.widgets.innerTransfers.futuresTypeA').toLowerCase() : vm.$t('mainPage.widgets.innerTransfers.futures').toLowerCase();
            return revert ? vm.$t('mainPage.widgets.innerTransfers.spotTypeA').toLowerCase() : vm.$t('mainPage.widgets.innerTransfers.spot').toLowerCase();
        }
    },
    methods: {
        onRetryHandler() {
            this.$store.dispatch('mainPageModules/loadSpotData');
            this.$store.dispatch('mainPageModules/loadFuturesData');
        },
        handleClickSetAll() {
            const vm = this;
            vm.transfersValue = this.NS(vm.storeState('innerTransfersWidget')[vm.transferDirection.directionFrom].additionalValue[vm.activeCurrency]).toString();
        },
        doTransfer() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.transferIsLoading = true;
                const requestBody = {
                    from_wallet: vm.transferDirection.directionFrom,
                    asset: vm.activeCurrency,
                    amount: this.NS(vm.transfersValue).toString()
                };
                const { directionTo } = vm.transferDirection;
                vm.$store.commit('mainPageModules/tempBlockFuturesFinres', true);
                const response = yield vm.services.mainService.doTransfer(requestBody);
                vm.transferIsLoading = false;
                if (response.success) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('mainPage.alerts.titles.transferExecuted'),
                        type: 'success',
                        autoDelete: true,
                        content: vm.$t('mainPage.alerts.content.transferSuccessful', { amount: requestBody.amount, asset: requestBody.asset, directionTo: directionTo === 'spot' ? 'с ' : 'со ', formatDirectionNameFrom: vm.$options.filters.formatDirectionName(requestBody.from_wallet, true, vm), formatDirectionTo: vm.$options.filters.formatDirectionName(directionTo, false, vm) })
                    });
                    vm.transfersFieldTouched = false;
                    vm.transfersValue = '';
                }
                else {
                    vm.$store.commit('mainPageModules/tempBlockFuturesFinres', false);
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('mainPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: (_a = response.data.errors.join('\n')) !== null && _a !== void 0 ? _a : vm.$t('mainPage.alerts.content.transferNotExecuted')
                    });
                    if (this.getFuturesSettings.multiAssets && response.status === 400) {
                        this.onRetryHandler();
                    }
                }
            });
        }
    },
    created() {
        if (this.isGateway) {
            this.$store.dispatch('mainPageModules/loadSpotData');
            this.$store.dispatch('mainPageModules/loadFuturesData');
        }
        this.platforms.futures.value = 'mainPage.widgets.innerTransfers.futures';
        this.platforms.spot.value = 'mainPage.widgets.innerTransfers.spot';
        const { coinToTransfer } = this.$route.query;
        this.activeCurrency = coinToTransfer !== null && coinToTransfer !== void 0 ? coinToTransfer : 'USDT';
        if (!coinToTransfer)
            return;
        this.transferDirection.directionFrom = this.transferDirection.directionTo;
        setTimeout(() => { this.handleClickSetAll(); }, 0);
        this.$router.replace({ query: null });
    }
});
